import type { Coercer } from 'superstruct';
import { is, Struct } from 'superstruct';

/**
 * Just like superstruct's built in `coerce`, except that
 * `laterCoerce` will run coercer after the struct's coercions.
 *
 * @example
 *      coerce(someStruct, number(), bar); // Will run bar first.
 * laterCoerce(someStruct, number(), bar); // Will run bar last.
 */
export function laterCoerce<T, S, C>(
	struct: Struct<T, S>,
	condition: Struct<C>,
	coercer: Coercer<C>
): Struct<T, S> {
	return new Struct({
		...struct,
		coercer: (value, ctx) => {
			const x = struct.coercer(value, ctx);
			return is(x, condition) ? coercer(x, ctx) : x;
		},
	});
}
